export const SPORTSNEW_LIST_STATUS = Object.freeze({
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS_NONEMPTY: 'success_nonempty',
  SUCCESS_EMPTY: 'success_empty',
  ERROR: 'error',
});

const requestKeyValue = (value, fallback = '') => (
  value == null || value === '' ? fallback : String(value)
);

export const sportsnewListRequestKey = (params = {}) => [
  requestKeyValue(params.mode),
  requestKeyValue(params.scope),
  requestKeyValue(params.sport, 'all'),
  requestKeyValue(params.league_id),
  requestKeyValue(params.game_title_id),
  requestKeyValue(params.tournament_id),
  requestKeyValue(params.page, '1'),
  requestKeyValue(params.limit, '30'),
].join('|');

export const fixtureRowsFromListResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.rows)) return data.rows;
  if (data && Array.isArray(data.fixtures)) return data.fixtures;
  if (data && Array.isArray(data.data)) return data.data;
  return null;
};

const responseCode = (response = {}) => String(
  response.code
  ?? response.data?.code
  ?? response.errorCode
  ?? response.error_code
  ?? '',
).trim().toUpperCase();

export const classifySportsnewListResponse = (response = {}) => {
  const httpStatus = Number(response?.httpStatus);
  const isHttpSuccess = Number.isFinite(httpStatus) && httpStatus >= 200 && httpStatus < 300;
  const code = responseCode(response);
  const retryAfterMs = Number(response?.retryAfterMs);
  const hasRetryAfter = response?.retryAfterMs != null
    && Number.isFinite(retryAfterMs)
    && retryAfterMs >= 0;

  const retryAfterError = hasRetryAfter
    && Number.isFinite(httpStatus)
    && (httpStatus < 200 || httpStatus >= 300)
    && httpStatus !== 429;
  if (httpStatus !== 429 && (code === 'SPORTSNEW_LIST_TRANSITION' || retryAfterError)) {
    return {
      status: SPORTSNEW_LIST_STATUS.ERROR,
      retryable: true,
      reason: code === 'SPORTSNEW_LIST_TRANSITION' ? 'transition' : 'retry_after',
    };
  }

  if (
    response?.status === false
    || !isHttpSuccess
    || response?.networkError
  ) {
    return { status: SPORTSNEW_LIST_STATUS.ERROR, retryable: false, reason: 'transport' };
  }

  const rows = fixtureRowsFromListResponse(response?.data);
  if (!rows) {
    return { status: SPORTSNEW_LIST_STATUS.ERROR, retryable: false, reason: 'malformed' };
  }

  return {
    status: rows.length > 0
      ? SPORTSNEW_LIST_STATUS.SUCCESS_NONEMPTY
      : SPORTSNEW_LIST_STATUS.SUCCESS_EMPTY,
    retryable: false,
    reason: 'success',
    rows,
  };
};

export const shouldRetrySportsnewList = (classification, retryCount) => (
  classification?.retryable === true && Number(retryCount) < 1
);

export const sportsnewListRetryDelayMs = (response = {}, now = Date.now) => {
  const normalizedMs = Number(response?.retryAfterMs);
  if (Number.isFinite(normalizedMs) && normalizedMs >= 0) return normalizedMs;

  const value = response?.retryAfter;
  if (value == null || value === '') return 0;

  const seconds = Number(value);
  if (Number.isFinite(seconds) && seconds >= 0) return seconds * 1000;

  const retryAt = Date.parse(value);
  return Number.isFinite(retryAt) ? Math.max(retryAt - now(), 0) : 0;
};
